import Storage from '../Storage/Storage';
import {ISettings} from '@src/@interfaces/services/Settings/ISettings';
import {IListener, ISubscription} from '@src/@interfaces/services/Events';
import {parseJsonSilently} from '@src/helpers/json/parseJsonSilently';

export default class Settings implements ISettings {
    protected bag = new Storage('settings@');

    get<V = any>(name: string): V | null {
        return this.parseJson(
            this.bag.get(name)
        );
    }

    has(name: string): boolean {
        return this.bag.has(name);
    }

    set(name: string, value: any): void {
        return this.bag.set(name, JSON.stringify(value));
    }

    onChanged<V = any>(listener: IListener<{ name: string, value: V | null }>): ISubscription {
        return this.bag.onChanged((event, payload) => {
            return listener(event, {
                ...payload,
                value: this.parseJson(payload.value),
            });
        });
    }

    getList(): Record<string, any> {
        const result = this.bag.getList();
        for (const key in result) {
            result[key] = JSON.parse(result[key]);
        }

        return result;
    }

    protected parseJson(json: string | undefined | null) {
        return json != null ? parseJsonSilently(json) : null;
    }
}
